<script>
    import { onMount } from "svelte";
    import { withResolvers } from "@otto-ec/assets-core-utils/promise";
    import { getAggregationFeatureLabels, getFeatureOrder } from "../utils/externalTrackingHelper.js";
    import SimpleCinema from "../components/SimpleCinema.svelte";
    import trackHypothetical from "../tracking/trackHypothetical.js";
    import { Logger } from "../utils/ft6bcn_logger.ts";

    let { data } = $props();
    const {
        headline,
        recommendations,
        tracking,
        additionalClickTracking,
        metaData,
        featuresState,
        hasPersonalisedRecommendations = false,
    } = data;

    const hypotheticalTracking = data.hypotheticalTracking;
    let index = $state("0");
    let cinemaInjectionContainerWidth = $state(1000);
    let featureIndex = $state("99");
    let additionalTrackingLabels = $state(null);
    let cinemaContainer;
    let trackingEventMergeId = $state(null);
    const [cinemaContainerMounted, mountSuccess] = withResolvers();

    const handleSquirrelSearchOpen = (context) => {
        Logger.log("Hypothetical tracking triggered for Last Seen Search Cinema");
        trackingEventMergeId = context.eventMergeId;
        if (data.hypotheticalTracking?.required) {
            trackHypothetical(hypotheticalTracking?.header, trackingEventMergeId);
        }
    };

    onMount(() => {
        if (window.o_global?.events) {
            window?.o_global?.events().on("squirrel.search.suggest.shown", handleSquirrelSearchOpen);
        }
        if (!data.onlyEmitHypotheticalTracking) {
            Logger.log("Mounting LastSeenSearchCinema");
            featureIndex = getFeatureOrder(cinemaContainer);
            additionalTrackingLabels = getAggregationFeatureLabels(cinemaContainer);
            cinemaInjectionContainerWidth = cinemaContainer.offsetWidth || 1000;
            mountSuccess();
        }
    });
</script>

<div bind:this={cinemaContainer}>
    {#if data.recommendations}
        <SimpleCinema
            headline={headline?.toUpperCase()}
            {recommendations}
            {tracking}
            {featureIndex}
            {additionalClickTracking}
            {additionalTrackingLabels}
            {cinemaInjectionContainerWidth}
            cinemaIndex={index}
            cinemaMeta={metaData}
            {featuresState}
            personalisedUser={hasPersonalisedRecommendations}
            {cinemaContainerMounted}
            {trackingEventMergeId}
            {hypotheticalTracking}
        />
    {/if}
</div>
